// extracted by mini-css-extract-plugin
export default {"wrapper":"SliderHero_wrapper__Edz+p","item":"SliderHero_item__y+tmx","children":"SliderHero_children__sumTk"};